
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/platform/logistics-and-fulfillment",
      function () {
        return require("private-next-pages/platform/logistics-and-fulfillment/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/platform/logistics-and-fulfillment"])
      });
    }
  